import * as actionTypes from "./constants";
import * as phases from "../utils/helpers/phases";
import { updateItemInArray, removeFromArray } from "../utils/helpers/immutable";
const initialState = {
  phase: phases.INIT,
  data: [],
  selected: 0
};
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USERS_REQUEST:
    case actionTypes.CREATE_USER_REQUEST:
    case actionTypes.UPDATE_USER_REQUEST:
    case actionTypes.DELETE_USER_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };
    case actionTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: state.data.concat(action.user)
      };
    case actionTypes.GET_USERS_REJECT:
    case actionTypes.CREATE_USER_REJECT:
    case actionTypes.UPDATE_USER_REJECT:
    case actionTypes.DELETE_USER_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };
    case actionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: action.users
      };
    case actionTypes.UPDATE_USER_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: updateItemInArray(
          state.data.findIndex(user => user.userId === action.user.userId),
          action.user,
          state.data
        )
      };
    case actionTypes.DELETE_USER_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: removeFromArray(
          state.data.findIndex(user => user.userId === action.userId),
          state.data
        )
      };
    case actionTypes.SELECT_USER:
      return {
        ...state,
        selected: action.userId
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/users/reducer.js